<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3 class="font-weight-bold">Reward Logs</h3>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="4">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search User..."
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    solo
                    rounded
                    v-model="filter.job_type"
                    :items="jobTypes"
                    clearable
                    @click:clear="(filter.job_type = null), (page = 1)"
                    label="Job Type"
                    @input="getData"
                    prepend-inner-icon="mdi-briefcase"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    solo
                    rounded
                    v-model="filter.execution_status"
                    :items="executionStatuses"
                    clearable
                    @click:clear="(filter.execution_status = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-check-circle"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="2">
                  <v-menu
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        solo
                        rounded
                        v-model="filter.from_date"
                        label="From Date"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="(filter.from_date = null), getData()"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.from_date"
                      @input="dateMenu = false"
                      @change="getData"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table v-else class="striped-table">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Sr. No.</th>
                      <th class="text-left">Job Type</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">User</th>
                      <th class="text-left">Phone</th>
                      <th class="text-left">Position</th>
                      <th class="text-left">Count</th>
                      <th class="text-left">Rewarded Points</th>
                      <th class="text-left">Balance Before</th>
                      <th class="text-left">Balance After</th>
                      <th class="text-left">Period</th>
                      <th class="text-left">Notification</th>
                      <th class="text-left">Date</th>
                    </tr>
                  </thead>
                  <tbody v-if="reward_logs && reward_logs.length != 0">
                    <tr
                      v-for="(log, i) in reward_logs"
                      :key="`log_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': reward_logs.length - 1 == i,
                      }"
                    >
                      <td>{{ i + 1 }}</td>
                      <td>
                        <v-chip
                          small
                          outlined
                          :color="getJobTypeColor(log.job_type)"
                          class="font-weight-medium"
                        >
                          {{ getJobTypeLabel(log.job_type) }}
                        </v-chip>
                      </td>
                      <td>
                        <v-chip
                          small
                          :color="getStatusColor(log.execution_status)"
                          text-color="white"
                          class="font-weight-medium"
                        >
                          {{ getStatusLabel(log.execution_status) }}
                        </v-chip>
                      </td>
                      <td>{{ log.user_name || "-" }}</td>
                      <td>{{ log.user_phone || "-" }}</td>
                      <td>{{ log.position ? log.position.name : "-" }}</td>
                      <td>{{ log.total_count || "0" }}</td>
                      <td class="font-weight-bold">{{ log.rewarded_points || "0" }}</td>
                      <td>{{ log.balance_before || "0" }}</td>
                      <td>{{ log.balance_after || "0" }}</td>
                      <td>{{ log.from_date }} to {{ log.to_date }}</td>
                      <td>
                        <v-chip
                          x-small
                          :color="log.notification_sent ? 'success' : 'grey'"
                          text-color="white"
                        >
                          {{ log.notification_sent ? "Sent" : "No" }}
                        </v-chip>
                      </td>
                      <td>{{ log.created_at || "" }}</td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="13" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "RewardLogsPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        job_type: "",
        execution_status: "",
        from_date: "",
      },
      reward_logs: [],
      jobTypes: [
        { id: 0, text: "All Types", value: "" },
        { id: 1, text: "Bonus Reward", value: "bonus_reward" },
        { id: 2, text: "Salesman Reward", value: "salesman_reward" },
      ],
      executionStatuses: [
        { id: 0, text: "All Status", value: "" },
        { id: 1, text: "Success", value: "success" },
        { id: 2, text: "Failed", value: "failed" },
        { id: 3, text: "Skipped", value: "skipped" },
      ],
      page: 1,
      paginationLength: 0,
      count: 0,
      isLoading: false,
      dateMenu: false,
    };
  },
  watch: {
    page: "getData",
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.job_type = this.filter.job_type
        ? this.filter.job_type
        : "";
      this.filter.execution_status = this.filter.execution_status
        ? this.filter.execution_status
        : "";
      this.filter.from_date = this.filter.from_date
        ? this.filter.from_date
        : "";

      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&job_type=" +
        this.filter.job_type +
        "&execution_status=" +
        this.filter.execution_status +
        "&from_date=" +
        this.filter.from_date +
        "&search_keyword=" +
        this.filter.search_keyword;

      await axios
        .get(`reward_logs?${query}`)
        .then((response) => {
          this.reward_logs = response.data.data;
          this.count = response.data.count;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
        });
      this.isLoading = false;
    },
    getJobTypeLabel(jobType) {
      const types = {
        bonus_reward: 'Bonus Reward',
        salesman_reward: 'Salesman Reward',
      };
      return types[jobType] || 'Unknown';
    },
    getJobTypeColor(jobType) {
      const colors = {
        bonus_reward: '#1976D2',
        salesman_reward: '#388E3C',
      };
      return colors[jobType] || '#757575';
    },
    getStatusLabel(status) {
      const statuses = {
        success: 'Success',
        failed: 'Failed',
        skipped: 'Skipped',
      };
      return statuses[status] || 'Unknown';
    },
    getStatusColor(status) {
      const colors = {
        success: '#388E3C',
        failed: '#D32F2F',
        skipped: '#F57C00',
      };
      return colors[status] || '#757575';
    },
  },
};
</script>
